"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyBreadcrumbs = void 0;

const NavigateNext_1 = __importDefault(require("@mui/icons-material/NavigateNext"));

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const renderBreadcrumbItems = props => {
  var _a;

  if (!((_a = props === null || props === void 0 ? void 0 : props.breadcrumbItems) === null || _a === void 0 ? void 0 : _a.length)) return [];
  return props.breadcrumbItems.map((item, index) => {
    const isLast = index === props.breadcrumbItems.length - 1;
    const textColor = isLast ? "text.primary" : "text.secondary";
    const dataTestId = item.dataTestId || `test-id-${index}`;
    return item.onClick ? react_1.default.createElement(material_1.Link, {
      "data-testid": dataTestId,
      style: {
        cursor: "pointer"
      },
      key: index,
      sx: {
        color: textColor
      },
      onClick: item.onClick
    }, item.content) : react_1.default.createElement(material_1.Typography, {
      "data-testid": dataTestId,
      key: index,
      sx: {
        color: textColor
      }
    }, item.content);
  });
};

const SskyBreadcrumbs = props => {
  return react_1.default.createElement(material_1.Breadcrumbs, {
    "data-testid": props.dataTestId,
    separator: react_1.default.createElement(NavigateNext_1.default, {
      fontSize: "small"
    })
  }, renderBreadcrumbItems(props));
};

exports.SskyBreadcrumbs = SskyBreadcrumbs;
exports.default = react_1.default.memo(SskyBreadcrumbs);